export const OrderId = (id) => {
    return `ESG-${id.toString().padStart(8, '0')}`;
}